import axios from "axios";

export const getGoogleAccount = (careersClientId) => {
  return axios
    .get(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/googleaccount/getGoogleAccount/" +
        encodeURIComponent(careersClientId)
    )
    .then((res) => res.data);
};

export const editGoogleAccount = (data) => {
  return axios
    .post(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/googleAccount/editGoogleAccount",
      data
    )
    .then((res) => res.data);
};

export const getGoogleKeys = () => {
  return axios
    .get(import.meta.env.VITE_ACTIVATE_BACKEND_API + "/api/googleaccount/getKeys")
    .then((res) => res.data);
};
